document.addEventListener("DOMContentLoaded", function () {
        let prods = window.product;
  function getCur() {
    const colorIdx = $("#sp-opt-group1 .sp-option.active").attr("data-val");
    const typeIdx = $("#sp-opt-group2 .sp-option.active").attr("data-val");
    const qtyIdx = $("#sp-opt-group3 .sp-option.active").attr("data-val");
  return prods.filter((item) => item.option1 == colorIdx&&item.option2==typeIdx&&item.option3==qtyIdx )[0];
  }
  function extractCurrencySymbol(priceString) {
  if (!priceString || typeof priceString !== 'string') return '';
  
  // 匹配开头的非数字、非小数点、非逗号的字符序列
  // 会匹配: $, €, £, ¥, US$, HK$, 等
  const match = priceString.match(/^[^\d\.,\-]+/);
  
  return match ? match[0] : '';
}

  function changePrice(){
        const unit = extractCurrencySymbol($('#sp_price1').text())
        const { currencyActiveInfo = {},currencyCurrent = "" } = window?._transcy?.variants
        const ratePrice = currencyActiveInfo?.detail?.convert[currencyCurrent] || 1
        let num = $('#calcNumber').val()
        let price = ((getCur().price * num * ratePrice) / 100).toFixed(2)
        let compare = ((getCur().compare_at_price * num * ratePrice) / 100).toFixed(2)
        //   price = (price + '').replace('.', ',')
        //   compare = (compare + '').replace('.', ',')
    
        $('#sp_price1').html(unit + price)
    
        $('#sp_price2').html(unit + compare)
        let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
        $(".off-font").html(off_font);
    
    }

  let getCurrentProductImages = function () {
    return $(".sp-img-p.active").first();
  };

  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  let endTimeG;

  function cutDownTime() {
    let nowTime = new Date();
    let endTime = new Date(endTimeG);

    let leftTime = endTime.getTime() - nowTime.getTime();
    if (leftTime < 0) {
      setupNewCountdown();
      leftTime = 0;
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60);
    leftH = leftH >= 10 ? leftH : "0" + leftH;
    leftM = leftM >= 10 ? leftM : "0" + leftM;
    leftS = leftS >= 10 ? leftS : "0" + leftS;

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    };
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9);
    const currentTime = new Date();
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
  }
  let intervalId;

  function getCutDownTime() {
    setupNewCountdown();
    if (intervalId) clearInterval(intervalId);
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime();
      $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
      $(".sp_top_cut_down .sp_left_view .sp_minute").html(
        cutDownTimeText.minute
      );
      $(".sp_top_cut_down .sp_left_view .sp_second").html(
        cutDownTimeText.second
      );
    }, 1000);
  }

  getCutDownTime();


  jQuery(".sp-scroll").slide({
    mainCell: ".nav-imgs",
    autoPlay: true,
    effect: "leftMarquee",
    interTime: 12,
    vis: 1,
    scroll: 1,
  });

  new Swiper('.mySwiper', {
    speed: 3000,
    autoplay: true,
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: "auto",
    spaceBetween: 0,
    loop: true,
    allowTouchMove: false,
  })

  // .sp-swiper2：逐实例初始化（分页指向各自 DOM）；.sp-part4 内与 .sp-text > .sp-item.active 双向同步
  function initSpSwiper2() {
    document.querySelectorAll(".sp-swiper2").forEach((swiperEl) => {
      const part4Section = swiperEl.closest(".sp-part4");
      const paginationEl = swiperEl.querySelector(".sp-pagination");
      let items = [];

      const options = {
        autoplay: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        slideShadows: true,
        slidesPerView: "auto",
        spaceBetween: 0,
        centeredSlides: true,
        loop: true,
      };

      if (paginationEl) {
        options.pagination = { el: paginationEl, clickable: true };
      }

      if (part4Section) {
        const listBox = swiperEl.parentElement;
        items = listBox
          ? listBox.querySelectorAll(".sp-text > .sp-item")
          : [];

        const setPart4ItemsActive = (index) => {
          if (!items.length) return;
          const n = items.length;
          const safe = ((index % n) + n) % n;
          items.forEach((item, i) => {
            item.classList.toggle("active", i === safe);
          });
        };

        options.on = {
          init: function () {
            setPart4ItemsActive(this.realIndex);
          },
          slideChangeTransitionEnd: function () {
            setPart4ItemsActive(this.realIndex);
          },
        };
      }

      const swiper = new Swiper(swiperEl, options);

      if (part4Section && items.length) {
        items.forEach((item, i) => {
          item.addEventListener("click", function () {
            if (typeof swiper.slideToLoop === "function") {
              swiper.slideToLoop(i);
            } else {
              swiper.slideTo(i);
            }
          });
        });
      }
    });
  }

  initSpSwiper2();

  // sp-part1：主图轮播与 .sp-round div.active 双向同步（移动端 + PC 各一套）
  function setPart1RoundActive(section, index) {
    const dots = section.querySelectorAll(".sp-round > div");
    if (!dots.length) return;
    const n = dots.length;
    const safe = ((index % n) + n) % n;
    dots.forEach((dot, i) => {
      dot.classList.toggle("active", i === safe);
    });
  }

  function initSpSwiperPart1() {
    document.querySelectorAll(".sp-part1 .sp-swiper1").forEach((swiperEl) => {
      const section = swiperEl.closest(".sp-part1");
      if (!section) return;
      const dots = section.querySelectorAll(".sp-round > div");

      const swiper = new Swiper(swiperEl, {
        autoplay: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        slideShadows: true,
        slidesPerView: "auto",
        spaceBetween: 0,
        centeredSlides: true,
        loop: true,
        watchSlidesProgress: true,
        on: {
          init: function () {
            setPart1RoundActive(section, this.realIndex);
          },
          slideChangeTransitionEnd: function () {
            setPart1RoundActive(section, this.realIndex);
          },
        },
      });

      dots.forEach((dot, i) => {
        dot.addEventListener("click", function () {
          if (typeof swiper.slideToLoop === "function") {
            swiper.slideToLoop(i, 0);
          } else {
            swiper.slideTo(i);
          }
        });
      });
    });
  }

  initSpSwiperPart1();

  new Swiper(".sp-swiper3", {
    autoplay: true,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: "auto",
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
    initialSlide: 1,
    pagination: {
      el: ".sp-pagination3",
      clickable: true,
    },
    navigation: {
      nextEl: ".sp-swiper-btn-next",
      prevEl: ".sp-swiper-btn-prev",
    },
  });

  new Swiper(".sp-swiper4", {
    speed: 9000,
    autoplay: true,
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: "auto",
    spaceBetween: 0,
    loop: true,
  });

  new Swiper(".sp-swiper-fade", {
    spaceBetween: 10,
    effect: "fade",
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 2000,
    },
    speed: 2000,
  });

  new Swiper(".sp-swiper-fade1", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 10,
    loop: true,
    on: {
      slideChange: function (e) {
        e.slides.find(".sp-text").each(function () {
          this.style.animation = "none";
        });
        const spText = e.slides.eq(e.activeIndex).find(".sp-text")[0];
        if (spText) {
          spText.style.animation = "none";

          spText.style.animation = `swiper-up-fade 0.5s ease forwards`;
        }
      },
    },
  });

  new Swiper(".sp-swiper0", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 10,
    loop: true,
  });

  function mainRender() {
    $(function () {
      $("#root").css("zoom", "normal");
      if (document.body.clientWidth <= 1060) {
        let scale = document.body.clientWidth / 1080;
        $("#root").css("zoom", scale);
      } else {
        const scale = document.body.clientWidth / 1920;
        $("#root").css("zoom", scale);
      }

      window.addEventListener(
        "resize",
        (function () {
          var timer;
          return function () {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
              $("#root").css("zoom", "normal");
              if (document.body.clientWidth <= 1060) {
                let scale = document.body.clientWidth / 1080;
                $("#root").css("zoom", scale);
              } else {
                const scale = document.body.clientWidth / 1920;
                $("#root").css("zoom", scale);
              }
            }, 100);
          };
        })()
      );
    });

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
      const config = {
        rootMargin: "0px 0px 1300px 0px",
        threshold: 0,
      };

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target;
            const dataSrc = image.getAttribute("data-src");
            if (dataSrc) {
              image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
            }
            lazyLoadObserver.unobserve(image); // 停止观察该图片
          }
        });
      },
        config);

      images.forEach(function (image) {
        lazyLoadObserver.observe(image); // 开始观察每个图片
      });
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach((subArray) => {
          subArray.forEach((url) => {
            const img = new Image();
            img.src = url;
          });
        });
      } else {
        // 处理一维数组
        imageArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      }
    }

    lazyLoadImages();

      window.cartCount > 0 && $('.sp-num').removeClass('sp-gray');

  
//   function changePrice() {
//   let num = $("#calcNumber").val();
//   let price = (getCur().price * num / 100).toFixed(2)
//   let compare = (getCur().compare_at_price * num / 100).toFixed(2)
//   // price = (price + '').replace('.', ',')
//   // compare = (compare + '').replace('.', ',')
//   $("#sp_price1 span").html(price);
//   $("#sp_price2 span").html(compare);
//   let off_font =
//   100 - Math.ceil((getCur().price / getCur().compare_at_price) * 100);
//   $(".font-off").html(off_font);
//   }



  $('.sp-btn-style').click(function(){
      let num = $('#calcNumber').val()
      let id = getCur().id
      window.location.href = '/cart/' + id + ':' + num
  })
    function preloadProductLayerImages() {
      const urls = [];
      $(".sp-product-module img").each(function () {
        const src = this.getAttribute("src");
        if (src) urls.push(src);
      });
      urls.push("https://cdn.shopify.com/s/files/1/0569/8476/4503/files/20260425-brand.png");
      preloadImages(urls);
    //   changePrice()
    }

    
// $(document).on('click', '.sp-option', function () {
//   setTimeout(changePrice, 10)
//   preloadProductLayerImages();
// })


    function setActiveLayerImage(layerSelector, dataKey, index) {
      var $imgs = $(layerSelector).find(".sp-img-p");
      if (!$imgs.length) return;
      var $target = $imgs.filter("[" + dataKey + '="' + index + '"]');
      $imgs.removeClass("active");
      if ($target.length) {
        $target.addClass("active");
      } else {
        $imgs.eq(0).addClass("active");
      }
         
    }

    function setQtyTag(qtyIdx) {
      var $tags = $(".sp-layer-qty .sp-qty-tag");
      $tags.removeClass("active");
      if (qtyIdx === 1 || qtyIdx === 2) {
        $tags.filter('[data-qty-index="' + qtyIdx + '"]').addClass("active");
      }

    }

    function updateProductModule() {
      var colorIdx = $("#sp-opt-group1 .sp-option.active").index();
      var typeIdx = $("#sp-opt-group2 .sp-option.active").index();
      var qtyIdx = $("#sp-opt-group3 .sp-option.active").index();
      
    function isMobile() {
      return document.body.clientWidth <= 1060;
    }

    if (isMobile()){
        $(".product-part .sp-img-wrap .sp-product-module .sp-layer-brand").css("padding-top", "227px");
    }else{
      if(typeIdx === 1){
        $(".product-part .sp-img-wrap .sp-product-module .sp-layer-brand").css("padding-top", "213px");
      }else {
        $(".product-part .sp-img-wrap .sp-product-module .sp-layer-brand").css("padding-top", "227px");
      }
    }
      if(typeIdx === 1){
        $(".sp-layer-qty").css("left", "326px");
        $(".sp-product-module").css("padding-top", "102px");
        $(".sp-product-module").css("padding-left", "150px");
        $(".sp-layer-color").addClass("sp-absolute");
      } else {
        $(".sp-layer-qty").css("left", "533px");
        $(".sp-product-module").css("padding-top", "0");
        $(".sp-product-module").css("padding-left", "0");
        $(".sp-layer-color").removeClass("sp-absolute");
      }

      if (colorIdx < 0) colorIdx = 0;
      if (typeIdx < 0) typeIdx = 0;
      if (qtyIdx < 0) qtyIdx = 0;

      setActiveLayerImage(".sp-layer-color", "data-color-index", colorIdx);
      setActiveLayerImage(".sp-layer-pro", "data-type-index", typeIdx);
      setQtyTag(qtyIdx);
        changePrice()
    }

    getCurrentProductImages = function () {
      var $pro = $(".sp-product-module .sp-layer-pro .sp-img-p.active");
      if ($pro.length) return $pro;
      return $(".sp-product-module .sp-img-p.active").first();
    };

    $(".product-part .opt-group .sp-option").click(function () {
      $(this).siblings().removeClass("active");
      $(this).addClass("active");

      var groupId = $(this).parent().attr("id");
      if (groupId === "sp-opt-group1" || groupId === "sp-opt-group2" || groupId === "sp-opt-group3") {
        updateProductModule();
      }
    });

    preloadProductLayerImages();
    // updateProductModule();

    // IOS字体多了间距的处理
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var isAndroid = /android/i.test(userAgent);
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent);

    if (!isAndroid && !isIOS && !isPC) {
      $(".sp_system").css("letter-spacing", "-4px");
    }



    // 平整的左右滑动轮播
    carouselSwiper = new Swiper("#carousel .swiper", {
      grabCursor: true,
      centeredSlides: false,
      slidesPerView: 'auto',
      spaceBetween: 20,    // 卡片之间的间距
      loop: true,
      autoplay: {
        delay: 0,
        stopOnLastSlide: false,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
        reverseDirection: false,
      },
      freeMode: {
        enabled: true,
        momentum: false,
      },
      speed: 5000,
      on: {
        touchEnd: function () {
          // 触摸结束后，强制重启自动播放
          var swiper = this;
          setTimeout(function () {
            swiper.autoplay.stop();
            swiper.autoplay.start();
          }, 50);
        },
        slideChangeTransitionEnd: function () {
          // 滑动过渡结束后，确保自动播放继续
          var swiper = this;
          setTimeout(function () {
            if (!swiper.autoplay.running) {
              swiper.autoplay.stop();
              swiper.autoplay.start();
            }
          }, 50);
        }
      }
    });

    // 定期检查并重启自动播放（作为备用方案）
    setInterval(function () {
      if (carouselSwiper && !carouselSwiper.autoplay.running) {
        carouselSwiper.autoplay.start();
      }
    }, 1000);



  }

  mainRender();

  // 找到所有跳转套餐的锚点链接 - 使用事件委托确保所有链接都能工作
  function handleShoppingLinkClick(event) {
    const link = event.target.closest('a[href="#shopping"]');
    if (!link) return;

    event.preventDefault();

    const targetElement = document.getElementById("shopping");
    if (targetElement) {
      const offsetTop = targetElement.offsetTop;
      let sptop = document.body.clientWidth <= 1080 ? 310 : 140;
      let zoomValue = parseFloat($("div#root").css("zoom")) || 1;
      const scrollTop = offsetTop * zoomValue - sptop * zoomValue;

      window.scrollTo({
        top: scrollTop,
        behavior: "smooth",
      });

      setTimeout(() => {
        if (window.pageYOffset === 0 || Math.abs(window.pageYOffset - scrollTop) > 100) {
          $('html, body').animate({
            scrollTop: scrollTop
          }, 800);
        }
      }, 100);
    }
  }

  // 使用事件委托在document上监听所有点击
  document.addEventListener('click', handleShoppingLinkClick);

  let sp_price1 = 39.99;
  let sp_price2 = 99.96;

  function calcTotal(price, num) {
    let result = Number(price) * Number(num);
    return result.toFixed(2);
  }
  $(".sp-reduce").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) - 1;
    if (num > 0) {
      input.value = num;
    }
    changePrice()
  });
  $(".sp-add").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) + 1;
    input.value = num;
    changePrice()
  });

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName("gradually");
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll("span, div");
    const paragraph = gradually.querySelector(".sp-sub-title");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 给每个 span/div 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`;
              span.style.animationDelay = `${index * 0.1}s`;

              const i = span.querySelector("i");
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`;
                i.style.animationDelay = `${index * 0.1}s`;
              }
            });

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3;
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade2 0.5s ease forwards`;
              paragraph.style.animationDelay = `${totalDelay}s`;
            }

            observer.unobserve(gradually);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observer.observe(gradually);
  }

  // 菜单
  $(".sp-menu-btn").click(function (e) {
    $(".sp-menu-mask").show();
  });

  $(".sp-menu-mask").click(function (e) {
    $(".sp-menu-mask").hide();
  });

  function getZoomValue() {
    let zoom = $("div#root").css("zoom");
    return parseFloat(zoom) || 1;
  }

  function handleScroll() {
    // let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    // let zoomValue = getZoomValue();
    // let headerHeight = $(".header:visible").height() * zoomValue;

    // if (scrollTop > headerHeight) {
    //   $(".sp-pc .sp-header-top").addClass("sp-fixed");
    // } else {
    //   $(".sp-pc .sp-header-top").removeClass("sp-fixed");
    // }
  }

  // 初始检查
  handleScroll();

  // 监听多种滚动事件
  window.addEventListener('scroll', handleScroll, true);
  document.addEventListener('scroll', handleScroll, true);

  $(function () {
    // 判断是否为移动端
    function isMobile() {
      return document.body.clientWidth <= 1060;
    }

    // 购物车加购动效
    $(".cart-btn").click(function () {
      $(this).children("img").addClass("on");
      if (isMobile()) {
        $(".sp-mobile .sp-cart .num").show();
        $(".sp-mobile .sp-cart").addClass("on");
        setTimeout(function () {
          $(".sp-mobile .sp-cart").removeClass("on");
        }, 500);
      } else {
        $(".sp-pc .sp-header-top .sp-cart .num").show();
        $(".sp-pc .sp-header-top .sp-cart").addClass("on");
        setTimeout(function () {
          $(".sp-pc .sp-header-top .sp-cart").removeClass("on");
        }, 500);
      }
      setTimeout(function () {
        $(".cart-btn").children("img").removeClass("on");
      }, 500);
    });

    let initNum = 0;

    $(".product-part .cart-btn").click(function () {
    //   let spNum = $("#calcNumber")[0].value;
    //   initNum += Number(spNum);

    //   // 更新购物车数量
    //   if (isMobile()) {
    //     $(".sp-mobile .cardNum").each(function () {
    //       $(this).html(initNum);
    //     });
    //   } else {
    //     $(".sp-pc .cardNum").each(function () {
    //       $(this).html(initNum);
    //     });
    //   }
    //   $(".cardNum").removeClass("sp-gray");
              var data = {
    id: getCur().id,
    quantity: $('#calcNumber').val(),
  };
 
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      success: function () {
        $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
             $(".cardNum").each(function() {
                $(this).html(result.item_count)
                $(this).removeClass('sp-gray')
             })

        });
      },
      dataType: "json",
    });

      var imgs = getCurrentProductImages();

      imgs.each(function () {
        var $img = $(this);
        var flyer = $img[0].cloneNode(true);
        flyer.classList.add("sp_clone");

        $(".product-part").append(flyer);
        $(flyer).css({
          width: $img[0].width,
          height: $img[0].height,
          background: "#e7e9ef",
          position: "fixed",
          top: $img[0].offsetTop,
          left: $img.offset().left,
          "z-index": 99,
        });

        let finish, targetTop, targetLeft;

        if (isMobile()) {
          // 移动端：飞向底部固定按钮中的购物车
          finish = $(".sp-btn-style2.sp-mobile .sp-cart");
          if (finish.length > 0) {
            targetTop = $(".sp-btn-style2")[0].offsetTop;
            targetLeft = $(".sp-btn-style2 .sp-cart")[0].offsetLeft + finish.width() / 2;
          } else {
            targetTop = 0;
            targetLeft = 0;
          }
        } else {
          // PC端：飞向header中的购物车
          finish = $(".sp-pc .sp-cart");
          if (finish.length > 0) {
            targetTop = finish[0].offsetTop + 20;
            targetLeft = finish[0].offsetLeft;
          } else {
            targetTop = 0;
            targetLeft = 0;
          }
        }

        $(flyer).animate(
          {
            top: targetTop,
            left: targetLeft,
            width: 50,
            height: 50,
            opacity: 0.4,
          },
          500,
          "linear",
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach();
              }
            );
          }
        );
      });
    });
  });

  // 问答
  $(".q-row").click(function () {
    $(this).parent().toggleClass("sp-show");
  });

  // 文本渐出动画
  const graduallyList2 = document.getElementsByClassName("sp-fade-box");
  for (let gradually2 of graduallyList2) {
    const paragraph2 = gradually2.querySelectorAll(".sp-ani");

    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph2.forEach((span, index) => {
              span.style.animation = `sp-fade-in 1s ease forwards`;
              span.style.animationDelay = `${index * 0.5 + 0.5}s`;
            });

            observerAni.unobserve(gradually2);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observerAni.observe(gradually2);
  }
  // 文本渐出动画
  const graduallyList3 = document.getElementsByClassName("sp-fade-box2");
  for (let gradually3 of graduallyList3) {
    const paragraph3 = gradually3.querySelectorAll(".sp-ani2");

    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph3.forEach((span, index) => {
              span.style.animation = `sp-fade-left 1s ease forwards`;
              span.style.animationDelay = `${index * 0.3 + 1}s`;
            });

            observerAni.unobserve(gradually3);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observerAni.observe(gradually3);
  }
});
